import type { Color } from "../types";

/**
 * Color resampler interface.
 */
export interface ColorResampler {
  /**
   * Returns resampled color for given destination image coordinates.
   *
   * @param x Destination image X pixel coordinate.
   * @param y Destination image Y pixel coordinate.
   * @returns Resampled pixel color.
   */
  getResampledColor(x: number, y: number): Color;

  /**
   * Sets scaling factor for super-sampling.
   *
   * @param scaling Scaling factor.
   */
  setScaling(scaling: number): void;

  /**
   * Returns scaling factor for super-sampling.
   */
  getScaling(): number;
}

/**
 * Checks if given argument implements ColorResampler interface.
 *
 * @param candidate
 */
export function isColorResampler(
  candidate: unknown
): candidate is ColorResampler {
  type C = Partial<ColorResampler>;
  return (
    typeof candidate === "object" &&
    candidate !== null &&
    typeof (candidate as C).getResampledColor === "function" &&
    typeof (candidate as C).setScaling === "function" &&
    typeof (candidate as C).getScaling === "function"
  );
}
